import styles from "./FormAddNewUser.module.css";
import { InputAndLabelTextBox } from "@/components/input/InputAndLabelTextBox/InputAndLabelTextBox";
import { InputAndLabelPasswordBox } from "@/components/input/InputAndLabelPasswordBox/InputAndLabelPasswordBox";
import { Select } from "@/components/select/Select/Select";
import { UserUtils, userStore } from "@/stores/UserStore";
import permissions from "@/data/permissions";
import { FullOverlayModalsControl } from "@/stores/FullOverlayModalsControl";
import { DefaultSwitch } from "@/components/switch/DefaultSwitch/DefaultSwitch";
import { Errors } from "./Errors";
import { useFormAddNewUser } from "@/hooks/User/useFormAddNewUser";
import { ButtonsBlock } from "./ButtonsBlock";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

interface FormAddNewUserProps {
  modalData: FullOverlayModalsControl;
  userData: UserUtils;
}

export const FormAddNewUser = observer(({ modalData, userData }: FormAddNewUserProps) => {
  const [switchs, setSwitchs] = useState<boolean>(false);
  const {
    //form actions
    register,
    handleSubmit,

    //form state
    formState: { errors },

    //form actions
    setRole,
    setActive,

    //submit
    onSubmit,
  } = useFormAddNewUser(userData);

  useEffect(() => {
    setRole(userStore.role || 1);
  }, []);

  return (
    <form className={styles.formAddNewUser}>
      <InputAndLabelTextBox
        idAndForHTML="login"
        labelText="Логин"
        props={{
          ...register("login", {
            required: "Заполните поле Логин",
          }),
          placeholder: "",
        }}
      />
      <InputAndLabelPasswordBox
        idAndForHTML="password"
        labelText="Пароль"
        props={{
          ...register("password", {
            required: "Укажите пароль",
          }),
          placeholder: "",
        }}
      />
      <InputAndLabelTextBox
        idAndForHTML="fio"
        labelText="ФИО"
        props={{
          ...register("fio"),
          placeholder: "",
        }}
      />

      <Select
        style={{ width: "100%" }}
        listSelect={permissions}
        defaultValue={userStore.role || 1}
        id={userStore.role || 1}
        valueBack={setRole}
      />

      <div className={styles.section}>
        <span>Активировать сразу?</span>
        <DefaultSwitch
          switchTriggerValue={switchs}
          returnValueFn={(e: boolean) => {
            setActive(e);
            setSwitchs(e);
          }}
          loading={false}
        />
      </div>

      <ButtonsBlock handleSubmit={handleSubmit} onSubmit={onSubmit} isHide={modalData.isHide} />
      <Errors errors={errors} />
    </form>
  );
});
